import React, { useState } from "react";
import Header from "../header/Header";
import PageHeading from "../pageHeading/PageHeading";
import Footer from "../footer/Footer";
import "./Userchat.scss";
import { Form } from "react-bootstrap";
import {
  SearchIcon,
} from "../Icons";
import UserImg from "../../assets/images/providerProfileImg.png";
import { useEffect } from "react";
import Newchat from "./Newchat";
import socket from "../../socket/socket";
import { fetchImage, formatTime } from "../../utils/common";
import { isLoading } from "../../slice/commonSlice";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
const Userchat = () => {
  const loading = useSelector(isLoading);
  const [showChat, setShowChat] = useState({});
  const [showContact, setShowContact] = useState(true);
  const [chatList, setChatList] = useState([]);
  const [searchKey, setSearchKey] = useState("");

  const handleShowChat = (chatdetails) => {
    setShowChat(chatdetails);
    setShowContact(false);
  };


  const loggedInuser = localStorage.getItem("users");
  const { id } = JSON.parse(loggedInuser);
  

  useEffect(() => {
    socket.emit("login", { _id: id });
  }, []);

  useEffect(() => {
    socket.emit("get-chat", { userID: id, searchKey });
    socket.on("show-chats-list", (data) => {
      setChatList(data);
    });
    socket.on("new-message-notification", (message) => {
      toast(`New message from ${message.senderName}: ${message.content}`, {
        position: "bottom-right",
        autoClose: 5000,
      });
    });
    return () => {
    };
  }, [socket, searchKey]);




  return (
    <>
      <Header />
      <PageHeading title="Message" />
      <div className="main-container">
        <div className="container-wrap">
          <div className="chat-wrapper">
            <div className={`chat-left ${showContact ? "show" : "hide"}`}>
              <div className="chat-search-wrapper">
                <div className="icon-wrap">
                  <SearchIcon />
                </div>
                <Form>
                  <Form.Control
                    type="text"
                    placeholder="Search here..."
                    onChange={(e) => {
                      setSearchKey(e?.target?.value);
                    }}
                  />
                </Form>
              </div>
              <div className="chat-contact-wrapper">
                {chatList?.length ? chatList.map((ele, index) => {
                  let chatUser = ele?.user?.filter((ele) => ele._id !== id);
                  let chatdetails = {
                    _id: ele?._id,
                    reciverID: chatUser[0]?._id,
                    firstName: chatUser[0]?.firstName,
                    lastName: chatUser[0]?.lastName,
                    blockedDetails: ele?.blockedUsers?.filter(
                      (blocked) => blocked?.blockedBy === id
                    ),
                    userId2: id,
                    profilePic: chatUser[0]?.profilePic,
                    lastMessage: ele?.lastMessage || null,
                    unseenMsgCount: ele?.unseenMessageCount?.find((msg) => msg?.userId === id)?.count || 0,
                  };

                  return <ChatContact key={index} chatdetails={chatdetails} handleShowChat={handleShowChat} />;
                }) : "It looks like you haven't started any conversations yet."}

              </div>
            </div>
            <Newchat showChat={showChat} socket={socket} />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Userchat;



const ChatContact = ({ chatdetails, handleShowChat }) => {
  const [profileImage, setProfileImage] = useState(null);

  useEffect(() => {
    const loadImage = async () => {
      if (chatdetails?.profilePic) {
        try {
          const fetchedImage = await fetchImage(chatdetails.profilePic);
          setProfileImage(fetchedImage);
        } catch (error) {
     
        }
      } else {
        setProfileImage(UserImg);
      }
    };
    loadImage();
  }, [chatdetails?.profilePic]); // Re-run when profilePic changes

  return (
    <div className="contact active" onClick={() => handleShowChat(chatdetails)}>
      <div className="contact-img-wrap">
        <div className="contact-img">
          <img src={profileImage || "/default-avatar.png"} alt="User" />
        </div>
        <div className="contact-status"></div>
      </div>
      <div className="contact-info-wrap">
        <div className="contact-name text-truncate">
          {chatdetails.firstName} {chatdetails.lastName}
        </div>
        <div className="contact-message text-truncate">
          {chatdetails?.lastMessage?.type === "image"
            ? "Image"
            : chatdetails?.lastMessage?.message || ""}
        </div>
      </div>
      <div className="contact-time-wrap">
        <div className="contact-last-viewed">
          {chatdetails?.lastMessage
            ? formatTime(chatdetails?.lastMessage?.createdAt)
            : ""}
        </div>
        {chatdetails?.unseenMsgCount > 0 && (
          <div className="contact-notification">{chatdetails.unseenMsgCount}</div>
        )}
      </div>
    </div>
  );
};
